import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";

import style from "./unMatch.module.css"

import * as messageAction from "../../../../../actions/Message";
import { useSocket } from "../../../../../Context/SockerContext";

const UnmatchModal = ({ personId, show, setShow }) => {
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const { socket } = useSocket();
  const formRef = useRef(null);
  const [selectedReason, setSelectedReason] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(show);

  useEffect(() => {
    if (show) {
      (async () => {
        setOpen(show);
        const response = await messageAction.getMatchReasons();
        const data = await response;
        if (response) {
          setOptions(data);
        }
      })();
    }
  }, [show]);

  async function unmatch(e) {
    e?.preventDefault?.(); // safe call if `e` is undefined or null

    const body = JSON.stringify({
      personId: personId,
      unmatchId: selectedReason, // use selectedReason directly
    });

    const response = await messageAction.updateMatchRequest(body);
    const data = await response;
    if (data) {
      socket?.emit("leave-room", sessionStorage.getItem("conversationId"));
      sessionStorage.removeItem("conversationId");
      navigate('/user/chat/matches')
    }
  }

  const handleSubmitReasons = () => {
    if (selectedReason) {
      setOpen(false);
      setShowConfirmModal(true);
    }
  };
  const handleClose = () => {
    setShow(false)
    setOpen(false)
  }

  return (
    <>
      <Modal
        className={style.customer_modal}
        size="sm"
        centered
        show={open}
      >
        <Modal.Body>
          <p
            style={{
              fontSize: "24px",
              fontWeight: "600",
              margin: "0",
              marginBottom: "1rem",
              color: "#6c6c6c",
            }}
          >
            Unmatch user?
          </p>
          <p
            style={{
              fontSize: "16px",
              margin: "0",
              textAlign: "center",
              color: "#6c6c6c",
            }}
          >
            Sure you’d like to unmatch?
            Help us understand why.
          </p>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              marginBlock: "1rem",
            }}
            ref={formRef} // still fine if you want to keep it
          >
            {options?.map((option) => (
              <label
                key={option.id}
                htmlFor={option.id}
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  color: "#6c6c6c",
                }}
              >
                <input
                  type="radio"
                  name="unmatchId"
                  id={option.id}
                  value={option.id}
                  onChange={() => setSelectedReason(option.id)}
                  checked={selectedReason === option.id}
                  style={{
                    accentColor: "#4E1173",
                    width: "20px",
                    height: "20px",
                  }}
                />
                <span>{option.name}</span>
              </label>
            ))}
          </form>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              gap: "1rem",
              marginInline: "auto",
            }}
          >
            <button
              type="button"
              className="global-cancel-button"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              type="button"
              className="global-save-button"
              disabled={!selectedReason}
              onClick={handleSubmitReasons}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showConfirmModal}
        centered
        size="sm"
        onHide={() => setShowConfirmModal(false)}
      >
        <Modal.Body style={{ textAlign: "center" }}>
          <p
            style={{
              fontSize: "20px",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#6c6c6c",
            }}
          >
            Confirm Unmatch
          </p>
          <p style={{ fontSize: "16px", color: "#6c6c6c" }}>
            Are you sure you want to unmatch this user?
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "1rem",
              marginTop: "1.5rem",
            }}
          >
            <button
              className="global-cancel-button"
              onClick={() => setShowConfirmModal(false)}
            >
              Cancel
            </button>
            <button
              className="global-save-button"
              onClick={(e) => {
                setShowConfirmModal(false);
                unmatch(e); // Calls the real unmatch logic
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UnmatchModal;
